// extracted by mini-css-extract-plugin
export var callCard = "_rn-0";
export var callMessageButton = "_rn-1";
export var helpIcon = "_rn-3";
export var helpIconContainer = "_rn-4";
export var verticalDivider = "_rn-2";